module.exports = require('./helpers/bundle-url').getBundleURL('c9iqF') + "subin.378040d7.png";